import { render, staticRenderFns } from "./ImpactBar.vue?vue&type=template&id=2173ef9a&scoped=true&"
import script from "./ImpactBar.vue?vue&type=script&lang=js&"
export * from "./ImpactBar.vue?vue&type=script&lang=js&"
import style0 from "./ImpactBar.vue?vue&type=style&index=0&id=2173ef9a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2173ef9a",
  null
  
)

export default component.exports